import {
  DefaultSystemBrowserOptions,
  InAppBrowser,
} from '@capacitor/inappbrowser';
import { isNative } from '@/domains/shared/utils/native';

export const openExternalLink = (url: string): void => {
  const trimmedUrl = url.trim();
  if (!trimmedUrl || trimmedUrl === '#') return;

  if (isNative()) {
    void InAppBrowser.openInSystemBrowser({
      url: trimmedUrl,
      options: DefaultSystemBrowserOptions,
    });
    return;
  }

  window.open(trimmedUrl, '_blank', 'noopener,noreferrer');
};
